<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<ng-container *ngIf="isLoading; else mainContent">
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</ng-container>

<ng-template #mainContent>
  <div class="page">
    <div class="container">
      <!-- Cabeçalho -->

      <!-- KITS -->
      <div class="section-kits">
        <h2 class="title">Editar detalhes do livro</h2>
        <p class="subtitle">Edite os detalhes do livro, adicione cursos e muito mais!</p>
        <div class="book-info">
          <div class="book-header row g-2">
            <div class="cover-box col-12 col-sm-6">
              <img
                [src]="response?.bookVersion?.bookFrontCoverFileName ? response?.bookVersion?.bookFrontCoverFileName : 'assets/images/book-placeholder.svg'"
                alt="Capa do livro" />
              <img
                [src]="response?.bookVersion?.bookBackCoverFileName ? response?.bookVersion?.bookBackCoverFileName : 'assets/images/book-placeholder.svg'"
                class="cover" alt="Capa traseira" />
            </div>
            <div class="book-info col-12 col-sm-6">
              <h1>{{ book?.bookTitle }}</h1>
              <p class="author">Por {{ book?.authorName }}</p>

              <div class="action-buttons">
                <button class="btn-add" style="background-color: #00c851; color: #fff; padding: 10px;" mat-raised-button
                  (click)="openPdf()">
                  Acessar o livro
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- KITS -->
      <div class="section-kits">
        <h2 class="title">Kits de venda</h2>
        <p class="subtitle">Monte diferentes combinações de itens para vender seu livro</p>

        <div class="kit-item" *ngFor="let kit of request.listKitStruct; let i = index"
          [ngClass]="{ 'disabled': !kit.isActive }">
          <div class="kit-row row g-3">
            <mat-form-field appearance="outline" class="field col-12 col-sm-6 col-md-3">
              <mat-label>Nome do kit</mat-label>
              <input matInput [(ngModel)]="kit.kitName" name="kitName{{i}}" [disabled]="!kit.isActive" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="field col-12 col-sm-6 col-md-3">
              <mat-label>Itens</mat-label>
              <mat-select multiple [(ngModel)]="kit.selectedItems" name="kitItems{{i}}" [disabled]="!kit.isActive"
                (selectionChange)="applyPriceGuards(kit)">
                <mat-option value="book">Livro físico</mat-option>
                <mat-option [disabled]="!bookVersion?.bookEbookFileName" value="ebook">E-book</mat-option>
                <mat-option value="video" [disabled]="!hasAnyCourse">
                  Curso / Vídeos
                </mat-option>
              </mat-select>
              <!-- Aviso quando o kit marcou vídeo, mas não há capítulos/curso -->
              <mat-hint *ngIf="$any(kit)?.__videoMissingWarn" class="warn-missing-course">
                Este kit foi desativado porque não existem capítulos/curso cadastrados.
              </mat-hint>
              <!-- Erro quando o kit está ativo mas sem nenhum item selecionado -->
              <mat-error *ngIf="kit.isActive && !kit.selectedItems?.length">
                Selecione pelo menos um item de venda no kit.
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="field col-12 col-sm-6 col-md-3">
              <mat-label>Valor total (R$)</mat-label>
              <input matInput [value]="formatCurrency(kit.totalPrice)" (keyup)="onCurrencyInput($event, kit)"
                (blur)="onCurrencyBlur(kit)" name="kitTotal{{ i }}" [disabled]="!kit.isActive" />

              <mat-hint>
                mín: {{ formatCurrency(getMinPriceForKit(kit)) }}
                <button mat-icon-button class="hint-help" tabindex="-1" [matTooltip]="
                  includesPhysicalBook(kit)
                    ? 'Mínimo = custo de produção do livro físico + impostos e taxas aplicados sobre o preço (nunca abaixo de R$ 10).'
                    : 'Mínimo = impostos e taxas aplicados sobre o preço (nunca abaixo de R$ 10).'
                " matTooltipPosition="above" matTooltipClass="tooltip-small">
                  <mat-icon>help_outline</mat-icon>
                </button>
              </mat-hint>

              <div class="profit-row">
                {{ includesPhysicalBook(kit) ? 'lucro estimado:' : 'margem estimada:' }}
                <strong [ngClass]="getEstimatedClass(kit)">
                  {{ formatCurrency(getEstimatedValue(kit)) }}
                  <!-- ({{ getEstimatedPercentLabel(kit) }}) -->
                </strong>
              </div>

              <!-- Quebra dos custos conforme novo cálculo -->
              <!-- <div class="hint-small" style="margin-top:4px; opacity:.8;">
                <ng-container>
                  Custos % ({{ ((costCalc?.platformProfitPercent || 0) + (costCalc?.baseTaxPercent || 0)) |
                  number:'1.0-2' }}%)
                  sobre {{ formatCurrency(kit.totalPrice || 0) }}
                  =
                  {{ formatCurrency(((kit.totalPrice || 0) * (((costCalc?.platformProfitPercent || 0) +
                  (costCalc?.baseTaxPercent || 0)) / 100)) || 0) }}
                  <ng-container *ngIf="includesPhysicalBook(kit)">
                    + Produção: {{ formatCurrency(costCalc?.unitCost || 0) }}
                  </ng-container>
                </ng-container>
              </div> -->
            </mat-form-field>

            <div class="kit-actions col-12 col-sm-6 col-md-3">
              <button class="btn-add" (click)="addKit()">
                <mat-icon>add</mat-icon>
              </button>
              <button class="btn-remove" *ngIf="request.listKitStruct.length > 1" (click)="removeKit(i)"
                matTooltip="Remover kit">
                <mat-icon>delete</mat-icon>
              </button>
              <button mat-icon-button
                [matTooltip]="kit.isActive ? 'Desativar Kit' : (canActivateKit(kit) ? 'Ativar Kit' : 'Adicione capítulos/vídeos para ativar')"
                (click)="toggleKitActive(i)" [disabled]="!kit.isActive && !canActivateKit(kit)">
                <mat-icon [ngClass]="kit.isActive ? 'icon-active' : 'icon-inactive'">
                  {{ kit.isActive ? 'visibility' : 'visibility_off' }}
                </mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>


      <!-- CAPÍTULOS DE VÍDEO COM ACORDEON -->
      <div class="section-kits">
        <div class="list-header">
          <h2 class="title">Vídeos e cursos</h2>
          <p class="subtitle">Crie conteúdo extra para seus clientes e alavanque suas vendas</p>
          <button mat-stroked-button color="primary" (click)="addChapter()">+ Capítulo</button>
        </div>

        <mat-accordion>
          <mat-expansion-panel *ngFor="let chapter of request.listVideoChapterStruct; let i = index">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ chapter.name || 'Capítulo ' + (i + 1) }}
              </mat-panel-title>
              <mat-panel-description>
                {{ chapter.description || 'Sem descrição' }}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="chapter-edit-grid">
              <!-- Coluna 1: Nome e descrição -->
              <div class="chapter-form">
                <mat-form-field appearance="outline" class="field">
                  <mat-label>Nome do capítulo</mat-label>
                  <input matInput [(ngModel)]="chapter.name" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="field">
                  <mat-label>Descrição</mat-label>
                  <textarea matInput rows="4" [(ngModel)]="chapter.description"></textarea>
                </mat-form-field>
              </div>

              <!-- Coluna 2: Upload de imagem do capítulo -->
              <div class="upload-box" (click)="triggerImageInput(i)">

                <ng-container *ngIf="getChapterImagePreview(chapter) as chapterImg; else seletorCapa">
                  <img class="upload-preview" [src]="chapterImg" alt="Imagem do Capítulo" />
                </ng-container>

                <ng-template #seletorCapa>
                  <div class="empty-state">
                    <strong class="upload-title">Arraste e solte seu arquivo aqui</strong>
                    <p class="upload-sub">Trabalhamos com .jpg, .png, .webp</p>
                    <p class="upload-size">Tamanho máximo: 5MB</p>
                    <button mat-flat-button color="primary">Selecionar arquivo</button>
                  </div>
                </ng-template>
              </div>
              <input #imageInput type="file" accept="image/*" hidden (change)="onImageUpload($event, i)" />
            </div>

            <hr />
            <p class="subtitle"
              style="display: flex; flex-direction: row; align-items: center; justify-content: space-evenly; font-weight: 600; font-size: 18px;">
              Arquivos</p>
            <div class="list-items">
              <div class="list-card" *ngFor="let video of chapter.listVideoStruct; let j = index">
                <div class="row g-3 align-items-stretch video-row">

                  <!-- COLUNA 1: Título + Descrição -->
                  <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                    <mat-form-field appearance="outline" class="w-100 mb-2">
                      <mat-label>Título</mat-label>
                      <input matInput [(ngModel)]="video.title" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Descrição</mat-label>
                      <textarea matInput rows="3" [(ngModel)]="video.description"></textarea>
                    </mat-form-field>
                  </div>

                  <!-- COLUNA 2: Arquivo de vídeo/PDF -->
                  <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div class="upload-box h-100"
                      [class.has-preview]="$any(video)?.__fileName || video.videoUrlFile || video.videoFile"
                      (click)="triggerFileInput(i, j)">
                      <div class="empty-state">
                        <strong class="upload-title">Arquivo de vídeo/PDF</strong>
                        <p class="upload-sub">.mp4, .mov, .webm, .avi, .pdf</p>
                        <p class="upload-size">Tamanho máx: 2GB</p>
                        <button mat-flat-button color="primary">Selecionar arquivo</button>
                      </div>

                      <!-- Mostra preview/label se houver arquivo selecionado OU algo visualizável -->
                      <div class="upload-preview d-flex flex-column gap-2 w-100"
                        *ngIf="getVisualizable(video) || $any(video)?.__fileName">
                        <video *ngIf="isUrl(video.videoUrlFile)" [src]="video.videoUrlFile" controls
                          style="width:100%; max-height:160px; border-radius:12px;"></video>

                        <div class="d-flex align-items-center gap-2">
                          <span class="file-label">{{ getLoadedFileLabel(video) }}</span>
                          <button type="button" mat-icon-button *ngIf="getVisualizable(video)"
                            (click)="openMediaInNewTab(video, $event)" matTooltip="Abrir em nova aba">
                            <mat-icon>open_in_new</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>

                    <input #videoInput type="file" accept="video/*,application/pdf" hidden
                      (change)="onFileUpload($event, i, j)" />
                  </div>

                  <!-- COLUNA 3: Miniatura -->
                  <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div class="upload-box h-100"
                      [class.has-preview]="getVideoThumbPreview(video) && getVideoThumbPreview(video) !== 'assets/images/book-placeholder.svg'"
                      (click)="triggerThumbInput(i, j)">
                      <div class="empty-state">
                        <strong class="upload-title">Miniatura</strong>
                        <p class="upload-sub">.jpg, .png, .webp</p>
                        <p class="upload-size">Tamanho máx: 2MB</p>
                        <button mat-flat-button color="primary">Selecionar imagem</button>
                      </div>

                      <img class="upload-preview" *ngIf="getVideoThumbPreview(video)"
                        [src]="getVideoThumbPreview(video)" alt="Thumbnail do vídeo" />
                    </div>
                    <input #thumbInput type="file" accept="image/*" hidden (change)="onVideoImagePick($event, i, j)" />
                  </div>

                  <!-- COLUNA 4: Botões -->
                  <div class="col-12 col-sm-12 col-md-12 col-lg-2 d-flex align-items-start gap-2 kit-actions">
                    <button class="btn-add" (click)="addVideo(i)" matTooltip="Adicionar vídeo">
                      <mat-icon>add</mat-icon>
                    </button>
                    <button class="btn-remove" *ngIf="chapter.listVideoStruct.length > 1" (click)="removeVideo(i, j)"
                      matTooltip="Remover vídeo">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>

            </div>

            <div class="actions-inline">
              <button mat-button class="btn-remove" style="color: #fff;" (click)="removeChapter(i)">Remover
                Capítulo</button>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>

      <!-- Ações -->
      <div class="details-actions">
        <div class="back-btn" (click)="goBack()">Voltar</div>
        <button class="continue-btn" (click)="save()" [disabled]="!canSave()">Salvar Alterações</button>
      </div>
    </div>
  </div>

</ng-template>
<app-footer></app-footer>